
import React from 'react';

export const BetaBanner: React.FC = () => {
  return (
    <div 
      className="fixed top-0 left-0 w-full bg-[#ea384c] text-white text-center text-xs font-bold px-4 py-2 z-50 flex items-center justify-center"
    >
      Versione beta
    </div>
  );
};
